"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const removeReservedMediaKeyWord = (mediaQueryString) => {
    return mediaQueryString.replace('@media', '').trim();
};
/**
 * Checks if the window width matches a specified media query. Useful when you need dynamic control over component rendering
 * or styles based on media query conditions.
 * @param {String} mediaQueryString
 * @param {Function} callback - Optional callback function to be called on query changes
 * @param {Function} callbackOnMatch - Optional callback function to be called when the media query matches
 * @returns {Boolean}
 *
 * https://developer.mozilla.org/en-US/docs/Web/API/Window/matchMedia
 * https://developer.mozilla.org/en-US/docs/Web/API/MediaQueryList/change_event
 *
 * Example:
 *    useMediaQuery('(max-width: 600px)');
 *    useMediaQuery('only screen and (min-width: 600px)');
 *    useMediaQuery('@media only screen and (min-width: 600px)');
 */
const useMediaQuery = (mediaQueryString, callback, callbackOnMatch) => {
    const queryString = removeReservedMediaKeyWord(mediaQueryString);
    const query = (0, react_1.useMemo)(() => window.matchMedia(queryString), [queryString]);
    const [matches, setMatches] = (0, react_1.useState)(query.matches);
    (0, react_1.useEffect)(() => {
        const listener = (e) => {
            callback?.();
            setMatches(e.matches);
            e.matches && callbackOnMatch?.();
        };
        query.addEventListener('change', listener);
        return () => {
            query.removeEventListener('change', listener);
        };
    }, [query]);
    return matches;
};
exports.default = useMediaQuery;
//# sourceMappingURL=useMediaQuery.js.map